import React from 'react';
import { Link, useParams } from 'react-router-dom';
import posts from './posts';
import usePageMeta from './usePageMeta';
import PostTile, { Cover, formatDate } from './PostTile';

function BlogPost() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  usePageMeta(
    post ? `${post.title} | Oneshoo Blog` : 'Post not found | Oneshoo Blog',
    post ? post.excerpt : undefined
  );

  if (!post) {
    return (
      <section className="section">
        <div className="container post-narrow">
          <h1>Post not found</h1>
          <p>
            There&apos;s no post at this address.{' '}
            <Link to="/blog">Back to the blog</Link>.
          </p>
        </div>
      </section>
    );
  }

  const more = posts.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <article className="blog-post">
      <header className="post-hero">
        <div className="container">
          <Link className="post-back" to="/blog">
            ← All posts
          </Link>
          <span className="post-date">
            {formatDate(post.date)}
            {post.draft && <span className="draft-badge">Draft</span>}
          </span>
          <h1>{post.title}</h1>
          <p className="post-standfirst">{post.excerpt}</p>
        </div>
      </header>

      {post.cover && (
        <figure className="post-cover">
          <Cover post={post} eager />
          {post.coverCaption && <figcaption>{post.coverCaption}</figcaption>}
        </figure>
      )}

      <div className="container post-narrow">
        <div className="post-body">{post.content}</div>
      </div>

      <aside className="post-more">
        <div className="container">
          <h2>More from the studio</h2>
          <div className="post-grid">
            {more.map((p) => (
              <PostTile key={p.slug} post={p} />
            ))}
          </div>
        </div>
      </aside>
    </article>
  );
}

export default BlogPost;
